let map,
    panorama;
const resetMapButton = document.getElementById('reset-map');
const backToMapButton = document.getElementById('back-to-map');
const panoramaElement = document.querySelector('#panorama');


function initMap() {
    map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 43.165356, lng: 6.184500 },
        zoom: 3,
        streetViewControl: false,
    });

    panorama = new google.maps.StreetViewPanorama(
        document.querySelector('#panorama'), {
            position: { lat: 43.165356, lng: 6.184500 },
            pov: {
                heading: 34,
                pitch: 10
            }
        });

    addMapListeners();
    panoramaElement.style.display = 'none';
    backToMapButton.style.display = 'none';

}

function addMapListeners() {
    resetMapButton.addEventListener('click', resetMap);
    backToMapButton.addEventListener('click', backToMap);
}

function addMarkerOnMap(dream) {
    const marker = new google.maps.Marker({
        position: dream.coordinate,
        map: map,
        icon: dream.done ? 'img/marker-done.png' : 'img/marker.png'
    });

    marker.addListener('click', function() {
        zoomOn(marker.getPosition());
    });


}

function zoomOn(position) {
    map.setZoom(20);
    map.setCenter(position);
    map.setMapTypeId('satellite');
}

function resetMap() {
    map.setZoom(3);
    map.setCenter({ lat: 43.164879, lng: 6.185045 });
    map.setMapTypeId('roadmap');
}

function backToMap() {
    panoramaElement.style.display = 'none';
    backToMapButton.style.display = 'none';
    resetMapButton.style.display = 'block';
}

function visitDreamOnMap(position) {
    panorama.setPosition(position);
    panoramaElement.style.display = 'block';
    backToMapButton.style.display = 'block';
    resetMapButton.style.display = 'none';
}


export { initMap, addMarkerOnMap, visitDreamOnMap };